<template>
    <BaseTooltip>
        <template #trigger>
            <BaseButton theme="neutral" size="sm" :aria-label="ariaLabel" :aria-expanded="isOpen" class="flex items-center gap-2" @click="handleClick">
                <i class="bi bi-journal-text text-2xl/none" aria-hidden="true"></i>
                <BaseChip v-if="visibleWidgetCount > 0" size="2xs">
                    {{ visibleWidgetCount }}
                </BaseChip>
            </BaseButton>
        </template>
        <template #content>
            {{ isOpen ? "Close Notes" : "Open Notes" }}
        </template>
    </BaseTooltip>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseChip from "~vue/components/BaseChip.vue";
import BaseTooltip from "~vue/components/BaseTooltip.vue";
import { computed } from "vue";

type ChatWidgetListToggleProps = {
    isOpen: boolean;
    visibleWidgetCount?: number;
};

const { isOpen, visibleWidgetCount = 0 } = defineProps<ChatWidgetListToggleProps>();

const emit = defineEmits<{
    click: [];
}>();

function handleClick() {
    emit("click");
}

const ariaLabel = computed(() => {
    return isOpen ? "Close Nadia notes" : `Open Nadia notes: ${visibleWidgetCount} ${visibleWidgetCount === 1 ? "note" : "notes"}`;
});
</script>
